// Slot di pianificazione Studio (1 = più alto in lista … 8 = più basso)
export const BANDS = Array.from({ length: 8 }, (_, i) => {
  const key = String(i + 1);
  return { key, label: `Slot ${key}` };
});
export const DEFAULT_BAND = '1';

const LEGACY_BAND_MAP = {
  top: '1',
  medio: '4',
  scommessa: '8',
};

/** Normalizza fascia legacy o slot libero a chiave `'1'`…`'8'`. */
export function normalizeBand(value) {
  const raw = String(value ?? '').trim().toLowerCase();
  if (LEGACY_BAND_MAP[raw]) return LEGACY_BAND_MAP[raw];
  if (/^[1-8]$/.test(raw)) return raw;
  return DEFAULT_BAND;
}